import _ from 'lodash';

import {
    ADD_TASK_SUCCESS,
    ADD_TASK_TYPE_SUCCESS,
    APPEND_TASKS,
    CLEAR_FEEDBACK_MESSAGES,
    GET_TASK_ACTION_TYPES_SUCCESS,
    GET_TASK_TYPES_SUCCESS,
    GET_TASKS_FAILURE,
    GET_TASKS_SUCCESS,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_TYPE,
    UPDATE_TASK_TYPE_SUCCESS
} from "./actions";

const initialState = {
    tasks: [],
    currentTask: null,
    pageable: null,
    successTaskTypeActionMessage: null
}

export default (state = initialState, action) => {
    function addOrUpdateTask(task){
        if(state.tasks && state.tasks.content) {
            const taskExists = _.findIndex(state.tasks.content, t => t.id == task.id);
            if (taskExists >= 0) {
                return {
                    ...state.tasks,
                    content: state.tasks.content.map((t, i) => i === taskExists ? task : t)
                };
            } else {
                return {
                    ...state.tasks,
                    content: [...state.tasks.content, task]
                };
            }
        }
        return state.tasks;
    }

    switch (action.type) {
        case GET_TASKS_SUCCESS:
            return Object.assign({}, state, {
                tasks: action.payload.response,
                pageable: action?.payload?.response?.pageable,
                totalElements: action?.payload?.response?.totalElements || 0,
                totalPages: action?.payload?.response?.totalPages || 0,
                tasksLoadFailed: false,
            });
        case APPEND_TASKS:
            return Object.assign({}, state, {
                tasks: {
                    ...action.payload.response,
                    content: [
                        ...(state.tasks.content || []),              // Keep existing tasks
                        ...(action.payload.response.content || [])   // Append new tasks
                    ]
                },
                pageable: action?.payload?.response?.pageable,
                totalElements: action?.payload?.response?.totalElements || 0,
                totalPages: action?.payload?.response?.totalPages || 0,
                tasksLoadFailed: false,
            });
        case GET_TASKS_FAILURE:
            return { ...state, tasksLoadFailed: true };
        case GET_TASK_TYPES_SUCCESS:
            return Object.assign({}, state, {
                taskTypes: action.payload
            });
        case GET_TASK_ACTION_TYPES_SUCCESS:
            return Object.assign({}, state, {
                taskActionTypes: action.payload
            });
        case ADD_TASK_SUCCESS:
            return Object.assign({}, state, {
                tasks: addOrUpdateTask(action.payload)
            });
        case UPDATE_TASK_SUCCESS:
            return Object.assign({}, state, {
                tasks: addOrUpdateTask(action.payload)
            });
        case ADD_TASK_TYPE_SUCCESS:
        case UPDATE_TASK_TYPE_SUCCESS:
            return {
                ...state,
                successTaskTypeActionMessage: action.payload
            }
        case CLEAR_FEEDBACK_MESSAGES:
            return {
                ...state,
                successTaskTypeActionMessage: null
            }
        default:
            return state;
    }
}
